import React, { useState, useEffect } from 'react';

const ToastNotification = ({ message, type, isDarkMode }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 3000); // Duración del toast
      return () => clearTimeout(timer);
    }
  }, [message]);

  if (!isVisible) return null;

  const colors = {
    success: isDarkMode ? 'bg-green-900/30 border-green-700 text-green-300' : 'bg-green-100 border-green-400 text-green-800',
    error: isDarkMode ? 'bg-red-900/30 border-red-700 text-red-300' : 'bg-red-100 border-red-400 text-red-800',
    warning: isDarkMode ? 'bg-yellow-900/30 border-yellow-700 text-yellow-300' : 'bg-yellow-100 border-yellow-400 text-yellow-800',
    info: isDarkMode ? 'bg-blue-900/30 border-blue-700 text-blue-300' : 'bg-blue-100 border-blue-400 text-blue-800',
  };

  return (
    <div className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg backdrop-blur-md border z-50 animate-fade-in-right ${colors[type] || colors.info}`}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">{message}</span>
        <button 
          onClick={() => setIsVisible(false)} 
          className={`ml-4 text-lg ${isDarkMode ? 'text-gray-300 hover:text-white' : 'text-gray-700 hover:text-gray-900'} transition-colors`}
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default ToastNotification;